import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Date formatters now live in @interioring/utils so portal, marketplace, and
// pro-sites all use the same en-IN locale + options. Re-exported here to keep
// existing portal call-site imports stable; new code should import from the
// shared module directly.
export {
	formatDate,
	formatDateLong,
	formatDateTime,
	formatDateTimeLong,
	formatDayMonth,
	formatMonthYear,
} from "@interioring/utils/format/date";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

// Indian numbering system formatters are portal-only and stay here.
// 200000 → "2,00,000"
export function formatIndianNumber(value: string | number): string {
	const num =
		typeof value === "string" ? value.replace(/\D/g, "") : String(value);
	if (!num) return "";
	return Number(num).toLocaleString("en-IN");
}

// "2,00,000" → "200000"
export function parseIndianNumber(value: string): string {
	return value.replace(/,/g, "");
}
